import { render, staticRenderFns } from "./SolictacoesAgendamento.vue?vue&type=template&id=538cc6bf&scoped=true"
import script from "./SolictacoesAgendamento.vue?vue&type=script&lang=js"
export * from "./SolictacoesAgendamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538cc6bf",
  null
  
)

export default component.exports